import React from 'react'
import { Field} from 'formik'
const File = (props) => {
    const {label, name, placeholder, ...rest } = props
    return (
        <div className="form-control">
            
            <Field id={name} name={name} {...rest} placeholder={placeholder}/>
            <span className="error">
            </span>
        </div>
    )
}

export default File
